// AUTO-GENERATED GraphQL Builder for BookingMilestoneShare
import * as Builders from '../';
export class BookingMilestoneShareBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  bookingMilestoneId(){ return this.add('bookingMilestoneId'); }
  bookingPackageId(){ return this.add('bookingPackageId'); }
  vendorId(){ return this.add('vendorId'); }
  amount(){ return this.add('amount'); }
  isAuto(){ return this.add('isAuto'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  bookingMilestone(b?:(q:Builders.BookingMilestoneBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingMilestone'))return this;
    this.v.add('bookingMilestone');
    const n=new Builders.BookingMilestoneBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingMilestone { ${inner} }`);
    return this;
  }

  bookingPackage(b?:(q:Builders.BookingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPackage'))return this;
    this.v.add('bookingPackage');
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackage { ${inner} }`);
    return this;
  }

  vendor(b?:(q:Builders.VendorBuilder)=>void){
    if(this.depth>=5||this.v.has('vendor'))return this;
    this.v.add('vendor');
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendor { ${inner} }`);
    return this;
  }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }
}
